<template>
    <!-- <div> -->
    <div id="cesiumContainer"></div>
    <!-- </div> -->
</template>

<script>
    import * as Cesium from "cesium/Cesium";
    import widget from "cesium/Widgets/widgets.css";

    export default {
        name: "CesiumScene",
        data() {
            return {
                vw: null,
                initialHeading:null,
                date: Date.now()
            };
        },
        mounted() {
            this.init();
        },
        beforeDestroy() {
        },
        methods: {
            init() {
                let viewerOption = {
                    geocoder: false, // 地理位置查询定位控件
                    homeButton: false, // 默认相机位置控件
                    timeline: true, // 时间滚动条控件
                    navigationHelpButton: false, // 默认的相机控制提示控件
                    fullscreenButton: false, // 全屏控件
                    scene3DOnly: true, // 每个几何实例仅以3D渲染以节省GPU内存
                    baseLayerPicker: false, // 底图切换控件
                    animation: true, // 控制场景动画的播放速度控件
                    shouldAnimate: true,
                
                    //关闭星星
                    skyBox: new Cesium.SkyBox({
                        show: true
                    }),
                };
                // console.log(this.$el,6666);
                let viewer = new Cesium.Viewer(this.$el, viewerOption);

                viewer.scene.sun.destroy(); //去掉太阳
                viewer.scene.sun = undefined; //去掉太阳
                viewer.scene.moon.destroy(); //去掉月亮
                viewer.scene.moon = undefined; //去掉月亮

                this.vw = viewer;
                this.initialHeading = viewer.camera.heading;
                viewer._cesiumWidget._creditContainer.style.display = "none";// 隐藏版权
                viewer.clock.onTick.addEventListener(this.rotate);
            },
            
           
            rotate() {
                let viewer=this.vw;
                var angle = 360 / 36;
                var delTime = Cesium.JulianDate.secondsDifference(viewer.clock.currentTime, viewer.clock.startTime);
                var heading = Cesium.Math.toRadians(delTime * angle) + this.initialHeading;
                viewer.scene.camera.setView({
                    destination :  new Cesium.Cartesian3(4401744.644145314, 225051.41078911052, 4595420.374784433), // 点的坐标
                    orientation: {
                        heading : heading,
                    }
                });
                
            }
        }
    };
</script>

<style lang='less' scoped>
    #cesiumContainer {
        width: 100%;
        height: 100%;
        margin: 0;
        padding: 0;
        overflow: hidden;
    }
</style>
